import React, { Component } from 'react';
import { Button, FormControl, FormGroup, ControlLabel, HelpBlock, Image } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import config from '../../constant/config';
import './AddUser.css';
import './AddUsersToGroup.css';

class AddUsersToGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernames: '',
      validUsernames: true,
      userOptions: this.props.hubUsers,
      userUpdated: false,
      users: [], // Store selected users for invitation
      copied: false,
    };
    this.renderMenuItemChildren = this.renderMenuItemChildren.bind(this);
  }

  onUserSelect(users) {
    this.setState({ users });
  }


  addUsersToGroup() {
    const { addUser } = this.props;
    if (this.state.users.length > 0) {
      for (const user of this.state.users) {
        addUser(user)
      }
    }
  }

  handleUserSearch(query) {
    this.setState({ userUpdated: false });
  }

  renderMenuItemChildren(option) {
    return (
      <div className="search-options">
        <Image className="avatar-image" src={`${config.spacesURL}/${option.avatarId}`} />
        <div className="name-container">{`${option.firstName} ${option.surname}`}</div>
      </div>
    );
  }

  async handleCopy() {
    try {
      await navigator.clipboard.writeText(window.location.origin+'/home?group_invite_token='+this.props.groupInvitationToken);
      this.setState({ copied: true })
      setTimeout(() => this.setState({ copied: false }), 2000); // reset copied after 2 seconds
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  render() {
    return (
      <div className="add-user-container">
        {!this.state.userUpdated &&
          <div>
            <FormGroup className="form" controlId="formUsernames" validationState={(!this.state.validUsernames) && 'error'}>
              <ControlLabel><strong>Add existing Hub Members by entering their usernames below. You can add multiple users by selecting each from the suggestions as you type.</strong></ControlLabel>
              <AsyncTypeahead
                className="typeahead__container"
                labelKey={option => `${option.firstName} ${option.surname}`}
                filterBy={['firstName', 'surname', 'emailAddress']}
                onSearch={query => this.handleUserSearch(query)}
                searchText="Searching..."
                emptyLabel="No Users"
                minLength={2}
                options={this.state.userOptions}
                onChange={e => this.onUserSelect(e)}
                useCache={false}
                renderMenuItemChildren={this.renderMenuItemChildren}
                multiple
                placeholder="Enter usernames separated by commas or select from suggestions"
              />
              {!this.state.validUsernames && <HelpBlock>Please enter valid usernames</HelpBlock>}
            </FormGroup>
            <div className="button-container">
              <Button className="adduser-button" onClick={() => this.addUsersToGroup()}>Add Users</Button>
            </div>
          </div>
        }
        <div className='invite-link-main-container'>
          <div className='general-text-container'>
            <div style={{padding: '20px', fontSize: '14px', fontWeight:'bold'}}>OR</div>
        <p style={{fontWeight:'bold'}}>Copy the link below to share it with users you would like to add to this hub and group.</p>
        <p style={{fontWeight:'bold'}}>
        New users will be prompted to create an account first and existing users signing in with this link will be automatically added to your hub and group. 
        They will also be automatically assigned any eLearning Course(s) that has been assigned to this group.
        </p>
        </div>
          <div>
              < div className='invite-link-text-container'>
              {
                this.props.create && 
                <p style={{fontWeight:'bold', color:'#14B4C8'}}>
                  Please save your new group and refresh the page in order to generate your group invite link.
                  You can then navigate back to this page and will see your new link displayed here ready to share.
                </p>
              }
                { !this.props.create && 
                <p style={{fontWeight:'bold', color:'#14B4C8'}}>
                  {window.location.origin}/home?group_invite_token={this.props.groupInvitationToken}
                </p>
                }
                </div>
                { !this.props.create && 
                <div className='invite-link-button-container'>
                <button
                  onClick={() => { this.handleCopy() }}
                  className="copy-button"
                >
                  Copy Link
                </button>
              </div>
  }
  
              {this.state.copied && <div> Copied! </div>}
            </div>
          </div>
                 
         </div>
    );
  }
}

export default AddUsersToGroup;
